export default {
  timeTab: {
    today: '1 Day',
    oneWeek: '5 Days',
    oneMonth: '20 Days',
    yearToDate: 'YTD',
  },
  footerText:
    'Price: x 1,000. Volume: x 1,000. Value: x 1,000,000. EOD data provided (Updated by 15:00 GMT+7)',
  treeMapBuyTitle: 'Buy %{tradeValue} Bn.',
  treeMapSellTitle: 'Sell %{tradeValue} Bn.',
  treeMapNetBuyTitle: 'Net buy %{tradeValue} Bn.',
  treeMapNetSellTitle: 'Net sell %{tradeValue} Bn.',
  tooltipBuyTitle: 'Proprietary Buy Value: ',
  tooltipBuyVolumeTitle: 'Proprietary Buy Volume: ',
  tooltipBuyNetTitle: 'Proprietary Net Buy Value: ',
  tooltipSellTitle: 'Proprietary Sell Value: ',
  tooltipSellVolumeTitle: 'Proprietary Sell Volume: ',
  tooltipSellNetTitle: 'Proprietary Net Sell Value: ',
  updatedDate: 'Updated Date: %{date}',
  PROPRIETARY_VALUE: 'Proprietary value',
  PROPRIETARY_NET: 'Net Proprietary value',

  treeMapTickerBuyTitle: 'Buy %{tradeValue} Mil.',
  treeMapTickerSellTitle: 'Sell %{tradeValue} Mil.',

  treeMapMilNetBuyTitle: 'Net buy %{tradeValue} Mil.',
  treeMapMilNetSellTitle: 'Net sell %{tradeValue} Mil.',
};
